import getProductTitle from './getProductTitle';
import { DEFAULT_TAB_TITLE } from '../consts';
export const getTabTitle = function () {
  let {
    productId,
    toolTitle,
    additionalInformation
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const productTitle = productId && getProductTitle(productId);
  if (productId && !productTitle) {
    console.warn(`Translation for ${productId} is missing - add it on @alloy/exo-skeleton-react`);
  }
  if (productTitle && toolTitle && additionalInformation) {
    return `${additionalInformation} - ${toolTitle} - ${productTitle}`;
  }
  if (productTitle) {
    if (toolTitle) {
      return `${toolTitle} - ${productTitle}`;
    }
    if (additionalInformation) {
      return `${additionalInformation} - ${productTitle}`;
    }
    return productTitle;
  }
  if (toolTitle) {
    if (additionalInformation) {
      return `${additionalInformation} - ${toolTitle}`;
    }
    return `${toolTitle}`;
  }
  if (additionalInformation) {
    return `${additionalInformation} - ${DEFAULT_TAB_TITLE}`;
  }
  return DEFAULT_TAB_TITLE;
};
//# sourceMappingURL=getTabTitle.js.map